import { render, staticRenderFns } from "./fileList.vue?vue&type=template&id=5b6b457a&scoped=true"
import script from "./fileList.vue?vue&type=script&lang=js"
export * from "./fileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b457a",
  null
  
)

export default component.exports